import { Box, ChakraProvider } from "@chakra-ui/react";
import { useRef } from "react";
import { theme } from "theme";
import zIndices from "theme/zIndices";

export const AppChakraProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const toastContainerRef = useRef<HTMLDivElement>(null);
  return (
    <ChakraProvider
      theme={theme}
      portalZIndex={zIndices.portal}
      toastOptions={{
        portalProps: {
          containerRef: toastContainerRef,
        },
      }}
    >
      {children}
      {/* https://github.com/chakra-ui/chakra-ui/issues/6276 */}
      <Box ref={toastContainerRef} zIndex="toast" />
    </ChakraProvider>
  );
};
